import i18next from "i18next";
import en from "./en.js";
import ru from "./ru.js";
import es from "./es.js";
import fr from "./fr.js";
import de from "./de.js";
import ja from "./ja.js";
import ko from "./ko.js";
import zh from "./zh.js";
import pt from "./pt.js";

function detectLanguage() {
    // Check URL parameter first
    var match = window.location.search.match(/[?&]lang=([a-z]{2})(?:&|$)/i);
    if (match) return match[1].toLowerCase();
    // Fall back to localStorage (set by landing page locale detection)
    try {
        var stored = localStorage.getItem('locale');
        if (stored && ['pt', 'es', 'fr', 'de', 'ru', 'ja', 'ko', 'zh'].indexOf(stored) !== -1) {
            return stored;
        }
    } catch (e) {}
    return 'en';
}

i18next.init({
    lng: detectLanguage(),
    debug: false,
    resources: {
        en,
        ru,
        es,
        fr,
        de,
        ja,
        ko,
        zh,
        pt
    }
});

export function currentLocale() {
    return i18next.language;
}

export default i18next.t;
